import React, {Component} from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

class ItemType extends Component {

    _handleFilerBrand = (brand) => {
        if(!brand) return

        const {onChangeFilter} = this.props
        if(typeof onChangeFilter === 'function') {
            onChangeFilter("brand", brand)
        }
    }

    render() {
        const {lazyload} = this.props

        return (
            <td className='ItemType'>
                {
                    lazyload ?
                    <LazyLoad>
                        {this.props.type}
                        {!!this.props.brand &&
                            <div className='ItemBrand mt-2 cursor-pointer'>
                                <span className="mr-2" onClick={() => this._handleFilerBrand(this.props.brand.name)}>{this.props.brand.name}</span>
                            </div>
                        }
                    </LazyLoad> : 
                    <>
                        {this.props.type}
                        {!!this.props.brand &&
                            <div className='ItemBrand mt-2 cursor-pointer'>
                                <span className="mr-2" onClick={() => this._handleFilerBrand(this.props.brand.name)}>{this.props.brand.name}</span>
                            </div>
                        }
                    </>
                }
                
            </td>
        )
    }
}

ItemType.propTypes = {
    type: PropTypes.string.isRequired,
}

export default ItemType
